import { GENDERS } from 'Data/constants.js'

export default function useDataTransform() {
  return GENDERS
}
